<template>
  <div>
    <div class="emd-tabbar jsTabbar _bordered">
      <ul class="emd-tabbar__list">
        <li class="emd-tabbar__item">
          <a
            class="emd-tabbar__link"
            v-on:click="changeTab('info')"
            v-bind:class="{ _active: tabActive === 'info' }"
          >
            <span class="emd-text">{{ $t('plan.detail.tab-info') }}</span>
          </a>
        </li>
        <li
          class="emd-tabbar__item"
          v-if="permissionIsEnabled('subscription:search')"
        >
          <a
            class="emd-tabbar__link"
            v-on:click="changeTab('subscriptions')"
            v-bind:class="{ _active: tabActive === 'subscriptions' }"
          >
            <span class="emd-text">{{
              $t('plan.detail.tab-subscriptions')
            }}</span>
          </a>
        </li>
      </ul>
    </div>
    <plan-info v-if="tabActive === 'info'"></plan-info>
    <plan-subscriptions
      v-if="tabActive === 'subscriptions'"
    ></plan-subscriptions>
  </div>
</template>

<script>
import PlanInfo from '@/views/Recurrences/Plans/PlansDetail/PlanInfo.vue'
import PlanSubscriptions from '@/views/Recurrences/Plans/PlansDetail/PlanSubscriptions.vue'
export default {
  components: {
    PlanInfo,
    PlanSubscriptions
  },
  data () {
    return {
      tabActive: 'info'
    }
  },
  methods: {
    changeTab (tab) {
      this.tabActive = tab
      this.$router
        .push({ name: 'plansDetail', params: { tab: tab } })
        .catch(err => err)
    },
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    }
  },
  beforeMount () {
    this.tabActive = this.$route.params.tab
  },
  mounted () {
    if (!this.$route.params.id.includes('plan_')) {
      this.$router.push({ name: 'plans' }).catch(err => err)
    }
  }
}
</script>
